var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.query.sort,
      callback: function ($$v) {
        _vm.$set(_vm.query, "sort", $$v);
      },
      expression: "query.sort"
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input, {
    loading: _vm.loading,
    items: _vm.items,
    label: '정렬'
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }